<template>
    <div class="container pt-5 mt-5">
      <iframe
        width="100%"
        height="600"
        src="https://www.youtube.com/embed/DJHDtplyehY"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </template>
  
  <script setup>
  
  </script>
  
  <style scoped>
  
  iframe {
    max-width: 100%;
    border: none;
  }
  </style>
  